import { render, staticRenderFns } from "./InsuranceCompanyCreateView.vue?vue&type=template&id=988adf1a"
import script from "./InsuranceCompanyCreateView.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports